export const SOCKET_ALERT: string = 'alert';
export const SOCKET_CONVERSATION: string = 'conversation';